import React from "react";
import "./Stats.css";
import teaching from "../../../../assets/img/teaching.jpg";
import graduates from "../../../../assets/img/graduates.jpg";
import students from "../../../../assets/img/students.jpg";
import whiteBg from "../../../../assets/img/white-bg.jpg";
const Stats = () => {
	return (
		<div className='uiowa-stats'>
			<div className='stat-wrapper'>
				<div className='stat'>
					<img src={teaching} alt='Teaching' />
				</div>
				<div className='stat'>
					<img src={whiteBg} alt='white background' />
					<div className='inner-stat'>
						<h1 className='title'>#35</h1>
						<h4>BEST PUBLIC UNIVERSITY, U.S. NEWS & WORLD REPORT</h4>
					</div>
				</div>
				<div className='stat'>
					<img src={graduates} alt='graduates' />
				</div>
				<div className='stat'>
					<img src={whiteBg} alt='white background' />
					<div className='inner-stat'>
						<h1 className='title'>15:1</h1>
						<h4>STUDENT-TO-FACULTY RATIO</h4>
					</div>
				</div>
				<div className='stat'>
					<img src={students} alt='students' />
				</div>
				<div className='stat'>
					<img src={whiteBg} alt='white background' />
					<div className='inner-stat'>
						<h1 className='title'>95%</h1>
						<h4>JOB/GRADUATE SCHOOL PLACEMENT RATE</h4>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Stats;
